<template>
  <the-nav></the-nav>
  <the-body></the-body>
</template>

<script>
export default {

};
</script>

<style>
@font-face {
  font-family: "cwTeXHei";
  font-style: normal;
  font-weight: 500;
  src: url(https://fonts.gstatic.com/ea/cwtexhei/v3/cwTeXHei-zhonly.eot);
  src: url(https://fonts.gstatic.com/ea/cwtexhei/v3/cwTeXHei-zhonly.eot?#iefix)
      format("embedded-opentype"),
    url(https://fonts.gstatic.com/ea/cwtexhei/v3/cwTeXHei-zhonly.woff2)
      format("woff2"),
    url(https://fonts.gstatic.com/ea/cwtexhei/v3/cwTeXHei-zhonly.woff)
      format("woff"),
    url(https://fonts.gstatic.com/ea/cwtexhei/v3/cwTeXHei-zhonly.ttf)
      format("truetype");
}
@font-face {
  font-family: 'cwTeXKai';
  font-style: normal;
  font-weight: 500;
  src: url(https://fonts.gstatic.com/ea/cwtexkai/v3/cwTeXKai-zhonly.eot);
  src: url(https://fonts.gstatic.com/ea/cwtexkai/v3/cwTeXKai-zhonly.eot?#iefix) format('embedded-opentype'),
       url(https://fonts.gstatic.com/ea/cwtexkai/v3/cwTeXKai-zhonly.woff2) format('woff2'),
       url(https://fonts.gstatic.com/ea/cwtexkai/v3/cwTeXKai-zhonly.woff) format('woff'),
       url(https://fonts.gstatic.com/ea/cwtexkai/v3/cwTeXKai-zhonly.ttf) format('truetype');
}

* {
  box-sizing: border-box;
}

html {
  font-family: "cwTeXKai", sans-serif;
}

body {
  margin: 0;
  padding: 0;
}
</style>